var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_211605_contact_icon",
    "data-name": "211605_contact_icon",
    d: "M59,48A11,11,0,1,0,70,59,11,11,0,0,0,59,48Zm0,21.085a10.069,10.069,0,0,1-7.726-3.612c.941-.407,3.289-1.253,4.775-1.687.116-.037.137-.042.137-.566a2.954,2.954,0,0,0-.2-1.248A6.34,6.34,0,0,1,55.5,60.3a3.773,3.773,0,0,1-.719-1.74A2.321,2.321,0,0,1,54.8,57.1a.671.671,0,0,0,.032-.1,9.53,9.53,0,0,0-.164-2.052,3.762,3.762,0,0,1,.793-2.713,4.027,4.027,0,0,1,3.067-1.481h.925a4.042,4.042,0,0,1,3.094,1.481,3.728,3.728,0,0,1,.788,2.713,9.51,9.51,0,0,0-.164,2.052.45.45,0,0,0,.032.09,2.282,2.282,0,0,1,.021,1.46,3.773,3.773,0,0,1-.719,1.74,6.4,6.4,0,0,1-.487,1.671,2.964,2.964,0,0,0-.349,1.232c0,.524.021.529.143.566,1.412.418,3.845,1.259,4.918,1.7A10.064,10.064,0,0,1,59,69.085Z",
    transform: "translate(-48 -48)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact_icon.008bdc428e59ac7763ef79813bb07d6c.svg";
export { ForwardRef as ReactComponent };